<template>
  <van-swipe
    class="my-swipe"
    :autoplay="3000"
    indicator-color="white"
    height="auto"
  >
    <van-swipe-item
      v-for="(item, index) in data"
      :key="index"
      @click="jumptoPage(item, index)"
    >
      <van-image
        width="100%"
        height="auto"
        lazy-load
        fit="cover"
        class="overflow-hidden rounded-14 display-block"
        :src="item.showPictures"
      />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  name: 'SwipeCard',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    jumptoPage (item, index) {
      if (!item.associatedCourses) {
        return ImagePreview({
          images: this.data.map((s) => s.showPictures),
          startPosition: index,
          closeable: true,
        })
      }
      this.$push({
        path: '/course/courseDetail',
        query: {
          id: item.associatedCourses,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-swipe__indicator {
    width: 6px;
    height: 6px;
    border: 1px solid #FFFFFF;
    background-color: transparent;
  }
  .van-swipe__indicators {
    left: 11%;
    top: 24px;
  }
}
</style>
